import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import { CircularProgress } from '@mui/material';

import { StyledBackdrop } from './styles';

interface LoaderContextType {
  isShowLoader: (show: boolean) => void;
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('useLoader must be used within a LoaderProvider');
  }
  return context;
};

export const LoaderProvider = ({ children }: { children: ReactNode }) => {
  const [isLoading, setIsLoading] = useState(false);

  const isShowLoader = useCallback(
    (show: boolean) => {
      setIsLoading(show);
    },
    [setIsLoading]
  );

  const value = useMemo(() => ({ isShowLoader }), [isShowLoader]);

  return (
    <LoaderContext.Provider value={value}>
      {children}
      <StyledBackdrop
        sx={(theme) => ({
          zIndex: theme.zIndex.drawer + 1,
        })}
        open={isLoading}
      >
        <CircularProgress />
      </StyledBackdrop>
    </LoaderContext.Provider>
  );
};
